// Function loadInstagramBlock loads the InstagramBlock class by dynamically importing the js on demand if needed

export function loadInstagramBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-instagram-block-chunk" */ '../widgets/instagramBlock').then(wg => {

		const { InstagramBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="InstagramBlock"]');

		if(!$wg) {
			// console.info('InstagramBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="InstagramBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new InstagramBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new InstagramBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopFeaturedGridItemBlock widget');

}
